import { BadgeType } from './badge-type-enum';

export const BADGE_TYPE_ICON_MAP: Record<BadgeType, string> = {
  [BadgeType.SUCCESS]: 'check_circle',
  [BadgeType.WARNING]: 'warning',
  [BadgeType.ERROR]: 'cancel',
  [BadgeType.INFORMATION]: 'info',
  [BadgeType.NEUTRAL]: 'fiber_manual_record',
  [BadgeType.EXPIRED]: 'event_busy',
};
